document.addEventListener("DOMContentLoaded", function() {
    // Message duplication logic
    const messageContainer = document.querySelector('.message-container');
    if (messageContainer) { // Proceed only if messageContainer exists
        const originalContent = messageContainer.innerHTML;
        const duplicationLimit = 7; // Adjust this as needed
        let newContent = originalContent.repeat(duplicationLimit + 1); // Efficient duplication using repeat()
        messageContainer.innerHTML = newContent;

        // Calculate and set animation duration
        const totalWidth = messageContainer.scrollWidth;
        const animationSpeedFactor = 50; // Adjust this value to control speed
        const animationDuration = totalWidth / animationSpeedFactor;
        messageContainer.style.animationDuration = animationDuration + 's';
    }

    // Viewer update logic
    let timer;
    const randomBetween = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;
    const updateViewers = (selector, initialRange, subsequentRange, delay) => {
        const element = document.querySelector(selector);
        if (element) {
            let randomNumber = randomBetween(...initialRange);
            element.innerHTML = `<b>${randomNumber}</b> are viewing this product right now`;

            timer = setTimeout(() => {
                randomNumber = randomBetween(...subsequentRange);
                element.innerHTML = `<b>${randomNumber}</b> are viewing this product right now`;
            }, delay);
        }
    };
    const resetTimer = () => clearTimeout(timer);

    // Attach event listeners to buttons for opening and closing modals
    document.querySelectorAll('.product-item__action-button[data-action="open-modal"]').forEach(button => {
        button.addEventListener('click', () => {
            setTimeout(() => updateViewers('#peopleViewing', [2, 6], [7, 15], 10000), 1000);
            setTimeout(() => updateViewers('#peopleViewingResp', [2, 6], [7, 15], 10000), 1000);
        });
    });

    document.querySelectorAll('[data-action="close-modal"]').forEach(button => {
        button.addEventListener('click', resetTimer);
    });

    // Initial call to update viewer counts
    updateViewers('#peopleViewing', [2, 6], [7, 15], 10000);
    updateViewers('#peopleViewingResp', [2, 6], [7, 15], 10000);
});